// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.78-TSS-3088-mcastro-INVITE-BUTTONS-Amending-Copy.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
